/**
 * Valor de una compra para Meta: `orders.subtotal` (decisión de Samuel,
 * 2026-10-09). Ese campo ya se guarda DESPUÉS del cupón y sin impuesto,
 * propina, envío ni donación, así que cuadra con «ventas netas» del reporte.
 * Es precio card, como lo guarda Redy: no se grossea ni se recalcula.
 *
 * Lo calcula el servidor y viaja en la respuesta (`conversion`): el pixel del
 * navegador y la Conversions API mandan el MISMO número.
 */
export type Conversion = { value: number; currency: "USD" }

export function conversionValue(order: { subtotal: number | string | null | undefined }): Conversion {
  const n = Number(order.subtotal)
  const value = Number.isFinite(n) && n > 0 ? Math.round(n * 100) / 100 : 0
  return { value, currency: "USD" }
}

/** Lo que llega en una respuesta: válido o undefined. Viene de la red. */
export function parseConversion(raw: unknown): Conversion | undefined {
  if (!raw || typeof raw !== "object") return undefined
  const r = raw as { value?: unknown; currency?: unknown }
  return typeof r.value === "number" && Number.isFinite(r.value) && r.value >= 0 && r.currency === "USD"
    ? { value: r.value, currency: "USD" }
    : undefined
}

export type PaidConversionRow = { subtotal?: number | string | null; payment_status?: string | null }

/** Para una orden ya escrita: solo una venta pagada tiene valor (la simulada nace `pending`). */
export function paidConversion(row: PaidConversionRow): Conversion {
  return conversionValue({ subtotal: row.payment_status === "paid" ? row.subtotal : 0 })
}
